import { setCookie } from '@avalara/bat-apps-shared/helpers/cookies';

import { isProdEnv } from './helpers';

const COOKIE_NAME = 'aviatorCrushPrompt';
// Only needs to survive the redirect hop into aviator-client - not persisted like the lead
// cookie, since aviator-client deletes it immediately after reading it (PF-8804).
const COOKIE_DURATION_MINUTES = 5;

// Mirrors the server's sanitizeCrushPrompt cap (src/server/routes/aviator-crush/index.ts) - this
// value never passes through that check, since it's read straight off the query string
// (crush-prompt.ts) and written to this cookie entirely client-side.
const MAX_CRUSH_PROMPT_LENGTH = 500;

// Identity's magic-link redirect_uri allowlist matches exactly, so an arbitrary crushPrompt
// value can't ride in the clientAppUrl sent to Identity - it goes in this cookie instead, which
// aviator-client reads on landing at `/aviator-crush` (PF-8804). Overwrites any existing value.
// A malformed value (empty, or too long) is dropped rather than written - it's a nice-to-have
// pre-fill, not core to signup.
export const setAviatorCrushPromptCookie = (prompt: string): void => {
  if (prompt.length === 0 || prompt.length > MAX_CRUSH_PROMPT_LENGTH) return;

  setCookie({
    name: COOKIE_NAME,
    value: prompt,
    isProduction: isProdEnv(),
    durationInMinutes: COOKIE_DURATION_MINUTES,
  });
};
